<template>
  <div v-if="showOverlay" class="overlay" @click.stop="closeUiElements"></div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

const uiKeys = ['isSearchOpen', 'isMarketSelectorOpen', 'isNavigationOpen', 'activeSlideIn']

export default {
  computed: {
    ...mapGetters('ui', uiKeys),
    showOverlay() {
      return this.isSearchOpen || this.isMarketSelectorOpen || this.isNavigationOpen || this.activeSlideIn
    }
  },
  watch: {
    showOverlay(newVal) {
      if(newVal) {
        document.querySelector('body').style.overflowY = 'hidden'
      } else {
        document.querySelector('body').style.overflowY = 'auto'
      }
    }
  },
  methods: {
    ...mapActions('ui', ['toggleValue']),
    closeUiElements() {
      _.forEach(uiKeys, key => {
        if(this[key]) {
          this.toggleValue({ key: key, data: false })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,.6);
  z-index: 100;
}
</style>
